<template>
  <div>
    <h1 class="text-center">Subscription Plans</h1>
    <router-link
      class="btn bg-green px-4 py-2 text-white rounded-full no-underline inline-block mb-2"
      to="/add-subscription-plan"
    >
      Add New Subscription Plan
    </router-link>
    <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"
import { formatAsRupees } from "@/utils/currency"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/subscription/plans?only_active=1`,
      tableConfig: [
        {
          header: { textContent: "Plan Name", sortingParam: "name" },
          classList: "w-1/3",
          path: "name",
        },
        {
          header: { textContent: "Installments" },
          path: "quantity",
        },
        {
          header: { textContent: "Billing" },
          path: "/",
          formatter: ({ interval, period }) =>
            `${interval === 1 ? "" : `${interval}-`}${period}`,
        },
        {
          header: { textContent: "Amount (per installment)" },
          path: "amount",
          formatter: formatAsRupees,
        },
        {
          header: { textContent: "Active" },
          path: "active",
          formatter: active => (active ? "✅" : "❌"),
        },
        {
          header: { textContent: "Cohort" },
          path: "/",
          formatter: ({ cohort: { name, id } }) =>
            `<a target="_blank" href="/cohort-edit/${id}">${name}</a><br><small>${id}</small>`,
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/edit-subscription-plan/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
}
</script>
